angular.module('impactx.search').filter('searchHighlight', function($sce, SearchService, AppConfiguration) {
    var filter = function(str, preventInHtmlTags) {
        if (!str) {
            return str;
        }
        if (AppConfiguration.get('useSearchHighlighting') && SearchService.lastSearchInput && SearchService.lastSearchInput.length > 0) {
            var termsToHighlight = SearchService.lastSearchInput.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            termsToHighlight = termsToHighlight.split(" ");
            if (termsToHighlight) {
                var termsToHighlightWithMinLength = "";
                for (var i = 0; i < termsToHighlight.length; i++){
                    if (termsToHighlight[i] && termsToHighlight[i].length > 1) {
                        if (termsToHighlightWithMinLength.length > 0) {
                            termsToHighlightWithMinLength += '|';
                        }
                        termsToHighlightWithMinLength += termsToHighlight[i];
                    }
                }
                var regex = new RegExp('(' + termsToHighlightWithMinLength + ')', 'gi');
                var tempString = str.replace(regex, '<span  md-colors="{background: \'accent-200\'}">$&</span>');
                if (preventInHtmlTags && AppConfiguration.get('allowHTMLinArticle')) {
                    tempString = clearUpHighlighting(tempString, "<", ">");
                    tempString = clearUpHighlighting(tempString, "&", ";");
                }
                return  $sce.trustAsHtml(tempString);
            }
            else {
                return $sce.trustAsHtml(str);
            }
        }
        else {
            return $sce.trustAsHtml(str);
        }
    };
    filter.$stateful = true;
    return filter;
});

function clearUpHighlighting(tempString, startTag, endTag) {
    const maxLoops = 50;
    var loopNumber = 0;
    var matches = [...tempString.matchAll(startTag)];
    if (matches.length > 0) {
        for (var i = 0; i < matches.length; i++) {
            var toReplaceString = tempString.substring(matches[i].index);
            if (toReplaceString.indexOf('<span  md-colors="{background: \'accent-200\'}">') < toReplaceString.indexOf(endTag) && toReplaceString.indexOf('<span  md-colors="{background: \'accent-200\'}">') > 0) {
                var splits = toReplaceString.split('<span  md-colors="{background: \'accent-200\'}">');
                if (splits.length > 1) {
                    splits[1] = splits[1].replace('</span>', "");
                    var replaceString = "";
                    for (var j = 0; j < splits.length; j++) {
                        replaceString += splits[j];
                        if (j > 0) {
                            replaceString += '<span  md-colors="{background: \'accent-200\'}">';
                        }
                    }

                    tempString = tempString.replace(toReplaceString, replaceString);
                    matches = [...tempString.matchAll(startTag)];
                    i = 0;
                    loopNumber++;
                    if (loopNumber >= maxLoops) {
                        break;
                    }
                }

            }
        }
    }
    return tempString;
}